import Swiper from 'swiper';
import {getOptionsFromJsonString} from "../../../../default/global/js/utilities/options";
import { Navigation} from "swiper/modules";

export function initSalesPersonSlider(query = document.querySelectorAll('.salesPersonSlider')) {
    for (let slider of query) {
        let options = getOptionsFromJsonString(slider.dataset.options, {
            autoplay_interval: 5000,
            eff_interval: 300,
        });
        Swiper.use([Navigation]);
        new Swiper(slider, {
            speed: options.eff_interval,
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            }, breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                },
                481: {
                    slidesPerView: 2.5,
                },
                768: {
                    slidesPerView: 3,
                },
                1250: {
                    slidesPerView: 4,
                },
                1540: {
                    slidesPerView: 5,
                }
            }
        });
    }
}
